import React, { Component } from 'react';
import config from 'react-global-configuration';

import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import AlertaInline from '../../Miscelania/AlertaInline';
import RequestApi from '../../Miscelania/RequestApi';

class ExamQuestionModal extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      treinamento: this.props.treinamento,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      training_id: this.props.training_id,
      team_training_id: this.props.team_training_id,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      modal: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  showModal(event) {
    this.setState({ modal: true });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  <button onClick={this.showModal} className='btn-block button-prova-finalizada'>VERIFICAR</button>

  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'medium'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Questão 3 de 18 - </b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row">
        <div className="col-md-12">
            <h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce dignissim ante eget quam tincidunt dapibus. Phasellus felis odio, accumsan ac bibendum ac, euismod in enim. Nunc maximus molestie sollicitudin. Suspendisse potenti. Cras ipsum augue, lobortis quis velit hendrerit, fringilla feugiat odio. Duis eu augue id leo placerat porta vel finibus neque.</h5>
        </div>
      </div>
      <br/>
      <div className="row">
        <div className="col-md-12">
          <table className="table tabela-questao-opcoes">
            <tbody>
              <tr>
                <td><input type="checkbox"/></td>
                <td></td>
                <td><span>a) </span>Morbi ut nulla eget nisl elementum scelerisque sit amet eget odio. Nam ornare purus odio, at cursus nisi iaculis vel. Sed lacinia felis id arcu interdum convallis.</td>
              </tr>
              <tr>
                <td><input type="checkbox"/></td>
                <td></td>
                <td><span>b) </span>Morbi ut nulla eget nisl elementum scelerisque sit amet eget odio. Nam ornare purus odio, at cursus nisi iaculis vel. Sed lacinia felis id arcu interdum convallis.</td>
              </tr>
              <tr>
                <td><input type="checkbox"/></td>
                <td></td>
                <td><span>c) </span>Morbi ut nulla eget nisl elementum scelerisque sit amet eget odio. Nam ornare purus odio, at cursus nisi iaculis vel. Sed lacinia felis id arcu interdum convallis.</td>
              </tr>
              <tr>
                <td><input type="checkbox"/></td>
                <td></td>
                <td><span>d) </span>Morbi ut nulla eget nisl elementum scelerisque sit amet eget odio. Nam ornare purus odio, at cursus nisi iaculis vel. Sed lacinia felis id arcu interdum convallis.</td>
              </tr>
              <tr>
                <td><input type="checkbox"/></td>
                <td></td>
                <td><span>e) </span>Morbi ut nulla eget nisl elementum scelerisque sit amet eget odio. Nam ornare purus odio, at cursus nisi iaculis vel. Sed lacinia felis id arcu interdum convallis.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-md-offset-3">
          <button className="btn-block button-modal-prova-questao-sair" onClick={()=>this.setState({ modal: false })}>SAIR</button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

export default ExamQuestionModal;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamQuestionModal.js